export default __webpack_public_path__ + "static/media/Honored Straps of the Mound.4f890087.jpg";